import { useQuery } from '@tanstack/react-query'

import type { TCorResponse as TCorLoteResponse } from '@/features/configuracoes/interfaces'
import { GetCoresService } from '@/features/configuracoes/services/get-cores-lotes-by-empreendimento-id-service'
import { coresKeys } from '@/features/configuracoes/utils/queries'

export const useGetCorLote = (idExterno: number) => {
  return useQuery<TCorLoteResponse>({
    queryKey: coresKeys.buscar(idExterno ?? 0),
    queryFn: async () => new GetCoresService().execute(idExterno).then((response) => response.data),
    enabled: !!idExterno,
  })
}
